/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPatientCategories } from 'app/entities/patient-category/patient-category.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './hospital-patient-category-attributes.reducer';

export const HospitalPatientCategoryAttributesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const patientCategories = useAppSelector(state => state.patientCategory.entities);
  const hospitalPatientCategoryAttributesEntity = useAppSelector(state => state.hospitalPatientCategoryAttributes.entity);
  const loading = useAppSelector(state => state.hospitalPatientCategoryAttributes.loading);
  const updating = useAppSelector(state => state.hospitalPatientCategoryAttributes.updating);
  const updateSuccess = useAppSelector(state => state.hospitalPatientCategoryAttributes.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/hospital-patient-category-attributes${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getPatientCategories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.multiplier !== undefined && typeof values.multiplier !== 'number') {
      values.multiplier = Number(values.multiplier);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...hospitalPatientCategoryAttributesEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      patientCategory: patientCategories.find(it => it.id.toString() === values.patientCategory?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...hospitalPatientCategoryAttributesEntity,
          hospital: hospitalPatientCategoryAttributesEntity?.hospital?.id,
          patientCategory: hospitalPatientCategoryAttributesEntity?.patientCategory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.hospitalPatientCategoryAttributes.home.createOrEditLabel"
            data-cy="HospitalPatientCategoryAttributesCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.home.createOrEditLabel">
              Create or edit a HospitalPatientCategoryAttributes
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-patient-category-attributes-id"
                  label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.categoryCode')}
                id="hospital-patient-category-attributes-categoryCode"
                name="categoryCode"
                data-cy="categoryCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.multiplier')}
                id="hospital-patient-category-attributes-multiplier"
                name="multiplier"
                data-cy="multiplier"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.active')}
                id="hospital-patient-category-attributes-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.cursor')}
                id="hospital-patient-category-attributes-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.lastUpdated')}
                id="hospital-patient-category-attributes-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.microSec')}
                id="hospital-patient-category-attributes-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.timestampEntry')}
                id="hospital-patient-category-attributes-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.startDate')}
                id="hospital-patient-category-attributes-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.endDate')}
                id="hospital-patient-category-attributes-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.suspended')}
                id="hospital-patient-category-attributes-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.addedByType')}
                id="hospital-patient-category-attributes-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.addedByID')}
                id="hospital-patient-category-attributes-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.modifiedByType')}
                id="hospital-patient-category-attributes-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.modifiedByID')}
                id="hospital-patient-category-attributes-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                id="hospital-patient-category-attributes-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-patient-category-attributes-patientCategory"
                name="patientCategory"
                data-cy="patientCategory"
                label={translate('tinyMedicRestApp.hospitalPatientCategoryAttributes.patientCategory')}
                type="select"
              >
                <option value="" key="0" />
                {patientCategories
                  ? patientCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/hospital-patient-category-attributes"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalPatientCategoryAttributesUpdate;
